<template>
    <div class="merchantVerification-page">
        <!-- 顶部Banner -->
        <div class="banner-box">
            <img src="../../../assets/images/shopTopImg.jpg" alt="商家认证banner" class="banner-img" />
        </div>
        <!-- 表单内容 -->
        <div class="form-wrapper">
            <div class="card" v-if="type == 1 && !authInfo.userName">
                <!-- 姓名 -->
                <label class="label"> <span class="labelRed">*</span> 姓名</label>
                <div class="form-item">
                    <input v-model="form.userName" type="text" placeholder="请输入姓名" class="input" />
                </div>

                <!-- 手机号 -->
                <label class="label"><span class="labelRed">*</span> 身份证号</label>
                <div class="form-item">
                    <input v-model="form.userAccount" type="tel" placeholder="请输入身份证号" class="input" />
                </div>
                <!-- 协议勾选 -->
                <div class="agree-box flexCenter">
                    <van-checkbox v-model="form.agree" shape="square" checked-color="#DC2627" icon-size="14px">
                        我已阅读并同意
                    </van-checkbox>
                    <div class="protocol-text" @click="onAgreement">《代理商不乱价协议》</div>
                </div>
                <!-- 底部保存按钮 -->
                <div class="submit-btn">
                    <button class="save-btn" :disabled="canSubmit" @click="submitForm">
                        提交认证
                    </button>
                </div>
                <!-- 温馨提示 -->
                <div class="tip-text">
                    温馨提示：请填写真实姓名和身份证号，提交后不支持自行修改，如需修改请联系客服。
                </div>
            </div>
            <div class="info-card" v-if="authInfo.userName">
                <!-- 成功图标+文字 -->
                <div class="success-icon-wrap">
                    <img src="../../../assets/images/success_rabbit.png" alt="提交成功" class="success-img">
                    <p class="success-text">您已提交认证</p>
                </div>

                <!-- 信息列表 -->
                <div class="info-list">
                    <div class="info-item">
                        <div class="flex">
                            <svg class="iconfontIcon" aria-hidden="true">
                                <use xlink:href="#icon-xingming"></use>
                            </svg>
                            <span class="labelInfo">姓名</span>
                        </div>

                        <span class="value">{{ authInfo.userName }}</span>
                    </div>
                    <div class="info-item">
                        <div class="flex">
                            <svg class="iconfontIcon" aria-hidden="true">
                                <use xlink:href="#icon-shenfenzhenghao"></use>
                            </svg>
                            <span class="labelInfo">身份证号</span>
                        </div>
                        <span class="value">{{ authInfo.userAccount }}</span>
                    </div>
                    <div class="info-item">
                        <div class="flex">
                            <svg class="iconfontIcon" aria-hidden="true">
                                <use xlink:href="#icon-tijiaoshijian"></use>
                            </svg>
                            <span class="labelInfo">提交时间</span>
                        </div>
                        <span class="value">{{ authInfo.dateTime }}</span>
                    </div>
                </div>

                <!-- 分割虚线 -->
                <div class="dash-line"></div>

                <!-- 底部提示文案 -->
                <p class="tip-desc">
                    温馨提示：提交认证后不支持自行修改认证信息，如需修改请联系客服。
                </p>
            </div>
            <div class="info-card" v-if="type == 3">
                <!-- 成功图标+文字 -->
                <div class="success-icon-wrap">
                    <img src="../../../assets/images/unfinished_rabbit.png" alt="提交成功" class="success-img">
                    <p class="fail-text">您未满足商家认证条件</p>
                </div>
                <p class="info-desc">
                    认证条件：您需要单个订单购买达到<span class="protocol-text"> 10 </span>盒商品才能提交认证
                </p>
                <van-button class="buy_button" block @click="goHome()">去购买</van-button>
            </div>

            <van-popup v-model:show="show" show-cancel-button round>
                <div class="delAddress_box">
                    <div class="popTitle">提交确认</div>
                    <span class="phone_call">提交后不支持自行修改信息，确认提交吗？</span>
                    <div class="phone_button_box">
                        <van-button class="phone_button_cancel phone_btn" @click="show = false">取消</van-button>
                        <van-button class="phone_button_sure phone_btn" :disabled='isLoading'
                            @click="handleSubmit()">确认提交</van-button>
                    </div>
                </div>
            </van-popup>

        </div>
        <van-overlay :show="isLoading">
            <div class="wrapper">
                <loading v-if="isLoading == true"></loading>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import loading from "../../components/loading/loading";
import service from "../../api/merchantVerification/index.js";
import { Toast } from "vant";
export default {
    components: {
        [Toast.name]: Toast,
        loading
    },
    data() {
        return {
            show: false,
            disabled: false,
            isLoading: false,
            type: '0',
            form: {
                userName: '',
                userAccount: '',
                agree: false
            },
            authInfo: {

            }
        }
    },
    computed: {
        canSubmit() {
            return this.form.userName.trim() && this.form.userAccount.trim() && !this.form.agree
        }
    },
    mounted() {
        this.getDetail()

    },
    methods: {
        // 提交验证
        submitForm() {
            if (!this.form.userName.trim()) return Toast('请输入姓名')
            if (this.form.userName.length > 100) return Toast('姓名最多可输入100个字符')
            if (!this.form.userAccount.trim()) return Toast('请输入身份证号')
            if (this.form.userAccount.length > 100) return Toast('身份证号最多可输入100个字符')
            if (!this.form.agree) {
                Toast('请勾选同意协议')
                return
            }
            this.show = true
        },

        handleSubmit() {
            this.isLoading = true
            service.post(this.form).then((res) => {
                if (res.statusCode == 200) {
                    Toast('提交成功')
                    this.init()
                }

            })
            // 提交
            setTimeout(() => {
                this.isLoading = false
            }, 2000);
            this.show = false

        },

        // 编辑情况下获取编辑详情
        getDetail() {
            this.isLoading = true
            service.getCheck().then(res => {
                if (res.statusCode == 200) {
                    if (res.data == 1) {
                        this.type = 1
                    }
                    if (res.data == 2) {
                        this.init()
                    }
                    if (res.data == 3) {
                        this.type = 3
                    }
                    console.log(res)
                    // this.init()
                }

            })
            setTimeout(() => {
                this.isLoading = false
            }, 2000);
        },
        init() {
            this.isLoading = true
            service.get().then((res) => {
                if (res.statusCode == 200) {
                    this.authInfo = res.data;
                    this.type = 2
                } else {
                    console.log(res)

                }

            })
            setTimeout(() => {
                this.isLoading = false
            }, 2000);
        },
        onAgreement() {
            this.$router.push('/agreement')
        },
        goHome() {
            this.$router.push('/page')
        }
    }

}
</script>

<style lang="less" scoped>
@deep: ~">>>";
@import '../../../assets/css/site.less';

/* 页面整体 */
.merchantVerification-page {
    width: 100%;
    min-height: 100vh;
    background-color: #f5f7fa;
    color: #65748B;
}

.iconfontIcon {
    width: 16px;
    height: 16px;

}

.van-popup--round {
    border-radius: 8px;
}

/* 表单容器 */
.form-wrapper {
    padding: 8px;
}

/* 卡片 */
.card {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    padding: 20px 0 0;
    margin-bottom: 8px;
}

/* 表单项 */
.form-item {
    display: flex;
    align-items: center;
    padding: 6px 6px;
    min-height: 26px;
    margin: 8px 16px 20px;
    /* height: 40px; */
    line-height: 20px;
    border-radius: 8px;
    /* background-color: rgba(249, 250, 252, 1); */
    color: rgba(148, 163, 184, 1);
    font-size: 14px;
    border: 1px solid rgba(226, 232, 240, 1);
}

.label {
    /* width: 110px; */
    font-size: 15px;
    // color: #333;
    flex-shrink: 0;
    margin-left: 16px;
    font-weight: bold;
    height: 22px;
    line-height: 22px;
    color: rgba(29, 41, 59, 1);
    font-size: 14px;
    text-align: left;
}

.labelRed {
    color: #DC2627;
}

.input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 14px;

    background: #fff;
}

.input::placeholder {
    color: #94A3B8;
}


/* // 头部横幅// */
.banner-box {
    width: 100%;

    .banner-img {
        width: 100%;
        display: block;
    }
}

.form-wrap {
    padding: 20px 16px;
}

.agree-box {
    margin: 24px;
    font-size: 12px;

}

@{deep}.van-checkbox__label {
    line-height: normal;
}


@{deep}.van-checkbox__icon .van-icon {
    border-radius: 2px;
}

.protocol-text {
    color: #DC2627;
}

.submit-btn {
    height: 40px;
    font-size: 14px;
    margin: 16px;
}

.save-btn {
    width: 100%;
    height: 40px;
    background: linear-gradient(267.84deg, rgba(240, 68, 68, 1) 1.1%, rgba(220, 38, 39, 1) 98.48%);
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: bold;
}

.save-btn:disabled {
    opacity: 0.6;
}


.tip-text {
    font-size: 12px;
    color: #65748B;
    margin: 24px;
    line-height: 20px;
}

.delAddress_box {
    width: 270px;
    height: 130px;
    background: #ffffff;
    border-radius: 4px !important;
    padding: 20px 16px 16px;
}

.popTitle {
    margin-bottom: 20px;
    font-size: 16px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    color: rgba(29, 41, 59, 1);
    font-weight: bold;
}

.phone_call {
    width: 100%;
    display: inline-block;
    height: 22px;
    line-height: 22px;
    color: rgba(29, 41, 59, 1);
    font-size: 14px;
}

.phone_button_box {
    margin-top: 24px;
    height: 40px;
    width: 100%;
    font-size: 14px;
    text-align: center;
}

.phone_btn {
    width: 130px;
    height: 40px;
    line-height: 40px;

}

.phone_button_cancel {
    float: left;
    border-radius: 8px;
    background-color: rgba(241, 245, 249, 1);
    color: rgba(71, 85, 105, 1);
    font-size: 14px;
    text-align: center;
    border: 1px solid rgba(226, 232, 240, 1);
}

.phone_button_sure {
    float: right;
    border-radius: 8px;
    background: linear-gradient(267.84deg, rgba(240, 68, 68, 1) 1.1%, rgba(220, 38, 39, 1) 98.48%);
    color: rgba(255, 255, 255, 1);
}

.buy_button {
    width: 200px;
    height: 40px;
    border-radius: 8px;
    background: linear-gradient(267.84deg, rgba(240, 68, 68, 1) 1.1%, rgba(220, 38, 39, 1) 98.48%);
    color: rgba(255, 255, 255, 1);
    margin: 0 auto 12px;
    font-weight: bold;
}


.info-card {
    background: #ffffff;
    border-radius: 8px;
    padding: 32px 12px 20px;
    margin-bottom: 8px;

    // 成功兔子+文字
    .success-icon-wrap {
        text-align: center;
        // margin-bottom: 30px;

        .success-img {
            width: 120px;
            height: auto;
            display: inline-block;
        }

        .success-text {
            font-size: 14px;
            color: #17A34A;
            margin: 16px 0 0;
            font-weight: 500;
            line-height: 22px;
        }

        // 未达标兔子+文字
        .fail-text {
            font-size: 14px;
            color: #DC2627;
            margin: 16px 0 0;
            font-weight: 500;
            line-height: 22px;
        }
    }

    // 认证条件
    .info-desc {
        font-size: 12px;
        line-height: 20px;
        margin: 32px 0;
        text-align: center;
    }

    // 信息条目
    .info-list {
        padding-top: 32px;

        .info-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 6px 0px;
            font-size: 14px;
            line-height: 22px;
            word-break: break-all;

            .value {
                color: #1D293B;
                flex: 1;
                text-align: right;
                margin-left: 12px;
            }
        }
    }

    .labelInfo {
        color: #65748B;
        margin-left: 6px;
    }

    // 虚线分割线
    .dash-line {
        height: 1px;
        background-image: linear-gradient(to right, #ccc 50%, transparent 50%);
        background-size: 8px 1px;
        margin: 14px 0 20px;
    }

    // 底部提示
    .tip-desc {
        font-size: 12px;
        line-height: 20px;
        margin: 8px 0 0;
    }

}
</style>